import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { SettingsContext } from "../../SettingsContext";
import UserCountryComponent from "./components/UserCountryComponent";
import UserGenderComponent from "./components/UserGenderComponent";
import UserAgeComponent from "./components/UserAgeComponent";
import {
    StyledSelect,
    StyledLabel,
    FormGroup
} from '../../../shared/layout/forms/FormElements';

import ItemCard from '../../../shared/layout/cards/ItemCard';

const TargetComponent = ({ target, index, onDelete }) => {
    const { siteSettings } = useContext(SettingsContext);
    const targetTypes = siteSettings?.getTargetTypes() || [];
    const [, forceUpdate] = useState(0);

    const selectedType = targetTypes.find(type => type.id === target.typeId);
    const selectedAttribute = selectedType?.attributes.find(attr => attr.id === target.attributeId);

    const handleTypeChange = (event) => {
        const newTypeId = event.target.value;
        target.typeId = newTypeId;
        target.attributeId = '';
        target.value = '';
        target.operator = '';
        forceUpdate((prev) => prev + 1);
    };

    const handleAttributeChange = (event) => {
        const newAttributeId = event.target.value;
        target.attributeId = newAttributeId;
        target.value = '';
        target.operator = '';
        forceUpdate((prev) => prev + 1);
    };

    const title = `Target ${index + 1}: ${selectedType?.name || 'New'} - ${selectedAttribute?.label || ''}`;

    return (
        <ItemCard title={title} onDelete={onDelete}>
            <FormGroup>
                <StyledLabel htmlFor="targetType">Target Type</StyledLabel>
                <StyledSelect
                    id="targetType"
                    value={target.typeId || ''}
                    onChange={handleTypeChange}
                >
                    <option value="">Select Target Type</option>
                    {targetTypes.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.name}
                        </option>
                    ))}
                </StyledSelect>
            </FormGroup>

            {selectedType && (
                <FormGroup>
                    <StyledLabel htmlFor="targetAttribute">Target Attribute</StyledLabel>
                    <StyledSelect
                        id="targetAttribute"
                        value={target.attributeId || ''}
                        onChange={handleAttributeChange}
                    >
                        <option value="">Select Attribute</option>
                        {selectedType.attributes.map(attr => (
                            <option key={attr.id} value={attr.id}>
                                {attr.name || attr.label}
                            </option>
                        ))}
                    </StyledSelect>
                </FormGroup>
            )}

            {selectedAttribute && (
                <div style={{ marginTop: '12px' }}>
                    {(() => {
                        switch (selectedAttribute.key) {
                            case 'age':
                                return (
                                    <UserAgeComponent
                                        value={target.value}
                                        operator={target.operator}
                                        onChange={(field, value) => {
                                            target[field] = value;
                                            forceUpdate((prev) => prev + 1);
                                        }}
                                        target="targets"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                    />
                                );
                            case 'gender':
                                return (
                                    <UserGenderComponent
                                        value={target.value}
                                        operator={target.operator}
                                        onChange={(field, value) => {
                                            target[field] = value;
                                            forceUpdate((prev) => prev + 1);
                                        }}
                                        target="targets"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                    />
                                );
                            case 'country':
                                return (
                                    <UserCountryComponent
                                        value={target.value}
                                        operator={target.operator}
                                        onChange={(field, value) => {
                                            target[field] = value;
                                            forceUpdate((prev) => prev + 1);
                                        }}
                                        target="targets"
                                        type={selectedType.key}
                                        attribute={selectedAttribute.key}
                                    />
                                );
                            default:
                                return null;
                        }
                    })()}
                </div>
            )}
        </ItemCard>
    );
};

export default TargetComponent;
